export function useApi() {
  const apiUrl = process.env.REACT_APP_API_URL;
  return apiUrl;
}
